import { VendorSaveUseCase } from '../../../../application';

export default class VendorSaveService {

    async execute(event) {
        const data = await VendorSaveUseCase(event);
        return data;
    }
}
